import { createContext, useContext } from 'react';

export const ThemeOptionsContext = createContext(null);

export const useThemeOptions = () => useContext(ThemeOptionsContext);
